<template>
  <div id="footer" class="container-fluid">
    <div class="container">
      <p class="title">联系我们</p>
      <hr>
      <div class="row">
        <div
          class="col-xs-12 col-sm-6 col-md-4 server-wrapper"
          v-for="(item,index) in serverList"
          :key="index"
        >
          <h5 style="margin-bottom: 15px;">{{ item.name }}</h5>
          <p style="margin-bottom: 6px;font-size: 14px;" v-if="item.company">单位：{{ item.company }}</p>
          <p style="margin-bottom: 6px;font-size: 14px;" v-if="item.email">邮箱：{{ item.email }}</p>
          <p style="margin-bottom: 6px;font-size: 14px;" v-if="item.phone">手机：{{ item.phone }}</p>
          <p style="margin-bottom: 6px;font-size: 14px;" v-if="item.tel">座机：{{ item.tel }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getContactData } from "../api/home";
export default {
  name: "Footer",
  data() {
    return {
      serverList: []
    };
  },
  created() {
    this.getContactData()
  },
  methods: {
    async getContactData() {
      const { data } = await getContactData({});
      this.serverList = data;
    }
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  padding: 30px 0;
  color: #fff;
  background: #2546B1;
  overflow: hidden;
  text-align: left;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue